import styled from 'styled-components';

export const ResumeHeader = styled.div`
  margin-block-end: 8px;
  button {
    flex-direction: row-reverse;
    padding-left: 0;
  }

  > div {
    margin-block-start: 40px;
  }
`;

export const InlineBanner = styled.div`
  margin-block: 36px;
`;
